import React from 'react';
import loadable from "@loadable/component";
import { Routes, Route, Navigate } from "react-router-dom";

// Sidebar Menu
import PageLayout from '../../layouts/PageLayout';
import menu from './data/menu.json';
import Error from '../../layouts/Error404';
import Loader from '../../layouts/Loader';

const LoadablePage = loadable((props) => import(`./pages/${props.page}`), {
    fallback: <Loader />,
    cacheKey: (props) => props.page
});

const GeneralRouter = () => {
    return (
        <React.Fragment>
            <PageLayout menu={menu}>
                <Routes>
                    <Route index element={<Navigate to='/portal/dashboard' />} />
                    <Route path='/dashboard' element={<LoadablePage page="Dashboard" />} />
                    <Route path='bills' >
                        <Route index element={<LoadablePage page="Bills/Index" />} />
                        <Route path=':billId' element={<LoadablePage page="Bills/Profile" />} />
                    </Route>
                    <Route path='/profile' element={<LoadablePage page="Profile/Index" />} />
                    <Route path='/events' element={<LoadablePage page="Events/Index" />} />
                    <Route path='/notifications' element={<LoadablePage page="Notifications/Index" />} />

                    <Route path="*" element={<Error />} />
                </Routes>
            </PageLayout>
        </React.Fragment>
    )
}

export default GeneralRouter;